module.exports = __webpack_public_path__ + "img/banner1.53c1618.png";